import { render, staticRenderFns } from "./SimpleProduit.vue?vue&type=template&id=2f0d4320&scoped=true&"
import script from "./SimpleProduit.vue?vue&type=script&lang=js&"
export * from "./SimpleProduit.vue?vue&type=script&lang=js&"
import style0 from "./SimpleProduit.vue?vue&type=style&index=0&id=2f0d4320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d4320",
  null
  
)

export default component.exports